import { useState, useEffect } from 'preact/hooks';

const Timer = props => {
  const [seconds, setSeconds] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setSeconds(seconds => seconds + 1);
    }, 1000 / props.playbackSpeed);
    return () => clearInterval(interval);
  }, []);

  return <div>{seconds}s</div>;
};

export default Timer;
